import React, { useEffect } from "react";
import { Text } from "@fluentui/react";
import { useMsal } from "@azure/msal-react";
import { useSearchParams } from "react-router-dom";

export const GlobalLogoutPage: React.FC = () => {

    const msal = useMsal();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        msal.instance.logoutRedirect({
            logoutHint: msal.accounts[0].idTokenClaims["login_hint"],
            postLogoutRedirectUri: searchParams.get("postLogoutRedirectUri")
        });
    }, []);

    return <Text>Logging out...</Text>
};
